import { LiveData, Service } from '@toeverything/infra';

export interface PaywallTrigger {
  /** Server-side feature name, e.g. 'analyze_run' / 'deep_research' / 'workspace_count'. */
  feature: string;
  /** Current usage at the moment the cap was hit. */
  used: number;
  /** The cap that was exceeded. */
  limit: number;
  /** Suggested upgrade target, used to render the CTA. */
  requiredPlan: string;
  /** Optional override for the modal heading. */
  title?: string;
  /** Optional override for the modal body. */
  description?: string;
}

/**
 * Singleton-style LiveData container for the global paywall modal.
 *
 * The GraphQL error interceptor (`GraphQLService.gql`) calls `show(trigger)`
 * when a `quota_exceeded` user-friendly error matches one of our Curiescious
 * feature quotas. The `<PaywallModal>` mounted in the app shell subscribes
 * to `trigger$` and opens itself when non-null.
 */
export class PaywallService extends Service {
  readonly trigger$ = new LiveData<PaywallTrigger | null>(null);

  show(trigger: PaywallTrigger) {
    this.trigger$.next(trigger);
  }

  dismiss() {
    this.trigger$.next(null);
  }
}
